import { BlockWidthContext } from '@infl-ts/util-block-width-context';
import { Box, Button } from '@mui/material';
import { useContext } from 'react';
import { Translation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Paginator = function Paginator(_ref) {
  var entitiesPerPage = _ref.entitiesPerPage,
      totalItems = _ref.totalItems,
      numberOfItems = _ref.numberOfItems,
      children = _ref.children,
      showMore = _ref.showMore;
  var blockWidth = useContext(BlockWidthContext);
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      flexDirection: 'column',
      display: blockWidth > 0 || false ? 'flex' : 'none'
    },
    "data-element": "Box",
    "data-component": "Paginator",
    "data-source-file": "index.tsx",
    children: [children, numberOfItems < totalItems ? /*#__PURE__*/_jsx(Button, {
      sx: {
        mt: 5,
        mx: 'auto'
      },
      variant: "outlined",
      onClick: showMore,
      children: /*#__PURE__*/_jsx(Translation, {
        children: function children(t) {
          return t("Show {{numChallenges}} more", {
            numChallenges: totalItems - numberOfItems > entitiesPerPage ? entitiesPerPage : totalItems - numberOfItems
          });
        }
      })
    }) : null]
  });
};